export default "__VITE_ASSET__8846bf0b__"